export type UserClaim = {
  claimType: ClaimType;
  parentClaim?: ParentClaim;
  claimResource: ClaimResource;
  claimPermission: ClaimPermission;
};

export enum ClaimType {
  Default,
  Permission,
}

export enum ClaimPermission {
  Edit = "edit",
  Read = "read",
  Switch = "switch",
}

export enum ParentClaim {
  LeftNavigation = "left-navigation",
  TopNavigation = "top-navigation",
}

export enum ClaimResource {
  Users = "users",
  CourseCatalog = "course-catalog",
  Enrollments = "enrollments",
  Certificates = "certificates",
  Application = "application",
}

export enum ImpersonationClaim {
  ImpersonatingUserEmail = "impersonating-user-email",
}
